import wrapLabelAndError from '../../behaviors/wrap_label_and_error';
import SelectField from '../SelectField/SelectField';

const SelectFieldWithLabel = wrapLabelAndError(SelectField);

export default SelectFieldWithLabel;
